import { render, staticRenderFns } from "./RevisionComponents.vue?vue&type=template&id=20ba7489&"
import script from "./RevisionComponents.vue?vue&type=script&lang=js&"
export * from "./RevisionComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports